module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_05.4291c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_05.png
// module id = Jb3S
// module chunks = 1